export default __webpack_public_path__ + "static/media/4-1-lg.dd783a89.jpg";